export const MAX_COMPANY_NAME_LENGTH = 100
